<template>
  <div class="featuredads" name="视频-改" v-if="video && video.video_url" ref="videoBox">
    <div class="video_box radius-8px over-h" style="position: relative">
      <img
        @click="ismuted = !ismuted"
        :src="ismuted ? '/static/images/mute.png' : '/static/images/sound.png'"
        alt=""
      />
      <img
        class="momday_videoplay"
        @click.stop="momdayPlay"
        :src="
          isplay
            ? '/static/images/community/video3.png'
            : '/static/images/community/video_paused.png'
        "
      />
      <video
        ref="videoEl"
        class="video_video"
        style="width: 100%; display: block"
        :poster="video.videoposter_url"
        :style="{ width: '100%', height: videoHeightRem + 'rem' }"
        :muted="ismuted"
        autoplay
        :controls="false"
        data-config="创客村"
        webkit-playsinline
        playsinline
        x5-playsinline
        @play="isplay = 0"
        @playing="isplay = 0"
        @ended="isplay = 1"
        x-webkit-airplay="allow"
      >
        <source :src="video.video_url" type="video/mp4" />
        <source :src="video.video_url" type="video/m3u8" />
        您的浏览器不支持HTML5视频
      </video>
    </div>
  </div>
</template>

<script>
import zymedia from '../../../assets/js/zy.media'
import adExposeMixin from '../js/adExposeMixin'

export default {
  name: 'featuredMomdayVideo',
  mixins: [adExposeMixin],
  props: {
    video: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      ismuted: true,
      isplay: 1,
      play_init: 1,
      zymedia_inited: false
    }
  },
  computed: {
    videoHeightRem() {
      if (!this.video || !this.video.width || !this.video.height) return 0
      const p_h = parseFloat(this.video.height) / parseFloat(this.video.width)
      return ((document.body.clientWidth / 100 - 0.22) * 100 * p_h) / 100
    }
  },
  watch: {
    'video.video_url'(url) {
      if (url) {
        this.$nextTick(() => {
          this.initZymedia()
          this.bindVideoExposeHandle()
        })
      }
    }
  },
  mounted() {
    if (this.video && this.video.video_url) {
      this.$nextTick(() => {
        this.initZymedia()
        this.bindVideoExposeHandle()
      })
    }
  },
  methods: {
    bindVideoExposeHandle: function () {
      if (this.$refs.videoBox && this.video) {
        this.bindAdExposeHandle(this.$refs.videoBox, 'momday_video', this.video)
      }
    },
    initZymedia() {
      if (this.zymedia_inited || !this.$refs.videoEl || !this.video.width || !this.video.height) {
        return
      }
      this.zymedia_inited = true
      zymedia(this.$refs.videoEl, {
        aspectRation: this.video.width / this.video.height,
        preload: 'auto',
        autoplay: true,
        enableVisibilityState: false,
        nativeControls: true,
        alwaysShowNativeControls: false,
        success() {}
      })
    },
    momdayPlay(type) {
      if (type == 'init' && !this.play_init) {
        return
      }
      const el = this.$refs.videoEl
      if (!el) return
      try {
        if (type == 'init') {
          el.play()
          this.play_init = 0
        } else {
          if (this.isplay == 0) {
            el.pause()
            this.isplay = 1
          } else {
            el.play()
            this.isplay = 0
          }
        }
      } catch (e) {}
    }
  }
}
</script>

<style scoped lang="scss">
.featuredads {
  margin: 0.1rem 0.11rem 0;
  border-radius: 0.1rem;
  overflow: hidden;
  img {
    width: 100%;
  }
  .video_box {
    img {
      position: absolute;
      right: 0.1rem;
      top: 0.15rem;
      z-index: 1;
      width: 0.2rem;
      height: 0.2rem;
      &.momday_videoplay {
        top: 0.45rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/homepage/components/featuredMomdayVideo.vue